import React from 'react'
import Layout from '../components/Layout'

export default function PageNotFound() {
  return (
    <Layout>
    <div className='w-full flex flex-col items-center h-screen justify-center text-3xl font-bold'>404.</div>
    </Layout>
  )
}
